import * as p from '@clack/prompts'
import type { Command } from 'commander'
import { INIT_COMMAND } from '@cli-constants/commands.js'
import { resolveCommandCwd } from '@cli-utils/paths.js'
import { findConfigFile } from '@core-engine/config/resolver/find-config-file.js'
export function requireInitializedProject(command: Command): void {
  if (command.name() === INIT_COMMAND) {
    return
  }

  const cwd = resolveCommandCwd(command)
  if (findConfigFile(cwd)) {
    return
  }

  p.log.error("Couldn't find betterstart project. Please run `betterstart init` first.")
  process.exit(1)
}
